



































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import PartieFormulaire from './components/PartieFormulaire.vue'
import InputCheckBox from './components/InputCheckBox.vue'
import InputText from './components/InputText.vue'
import InputSelect from './components/InputSelect.vue'
import InputFormulaire from './components/InputFormulaire.vue'
import ContentPartieAuto from './components/ContentPartieAuto.vue'
import InputFile from './components/InputFile.vue'
import InputEmail from './components/InputEmail.vue'
import InputDateTime from './components/InputDateTime.vue'
import InputDate from './components/InputDate.vue'
import InputNumber from './components/InputNumber.vue'
import InputPhone from './components/InputPhone.vue'
import InputRadio from './components/InputRadio.vue'
import InputTextArea from './components/InputTextArea.vue'
import InputChoixMultiple from './components/InputChoixMultiple.vue'
import ZoneTextInfo from './components/ZoneTextInfo.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import './styles/custom-bootstrap.scss'
import { FormulaireInterface } from './types/Exa_Formulaire'
import { TypeInput, InputInterface } from './types/Exa_Input'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faPlus, faTrashAlt, faPen, faArrowDown, faArrowUp, faArrowsAltV, faFlag, faExclamationTriangle, faDownload, faFileDownload, faFile, faFileUpload, faFileAlt, faCheck, faEye, faTimes } from '@fortawesome/free-solid-svg-icons'

import { PartieFormulaireInterface, TypePartie, getTypePartieSpec } from './types/Exa_PartieFormulaire'
import * as formulaire from './store/modules/Exa_Formulaire'
import * as partieFormulaire from './store/modules/Exa_PartieFormulaire'
import * as input from './store/modules/Exa_Input'
import { registerOrCreateStore } from './utils/helpers'
import { isNull } from 'lodash'
import { BButton, BModal } from 'bootstrap-vue'
import Visionneuse from './components/Visionneuse.vue'

library.add(faPlus, faTrashAlt, faPen, faArrowDown, faArrowUp, faArrowsAltV, faFlag, faExclamationTriangle, faDownload, faFileDownload, faFileUpload, faFile, faFileAlt, faCheck, faEye, faTimes)


@Component({
    computed: {
        ...mapGetters('exa_formulaire', ['parties', 'partiesAutomatiques', 'libelle', 'description', 'partieSelect', 'getJson', 'getJsonValues'])
    },
    components: {
        FontAwesomeIcon: FontAwesomeIcon,
        'b-button': BButton,
        'b-modal': BModal,
        PartieFormulaire: PartieFormulaire,
        InputCheckBox: InputCheckBox,
        InputText: InputText,
        InputSelect: InputSelect,
        InputFormulaire: InputFormulaire,
        Visionneuse: Visionneuse,
        ContentPartieAuto: ContentPartieAuto,
        InputFile: InputFile,
        InputEmail: InputEmail,
        InputDateTime: InputDateTime,
        InputDate: InputDate,
        InputNumber: InputNumber,
        InputPhone: InputPhone,
        InputRadio: InputRadio,
        InputTextArea: InputTextArea,
        InputChoixMultiple: InputChoixMultiple,
        ZoneTextInfo: ZoneTextInfo
    }
})

export default class Formulaire extends Vue {
    @Prop() structureFormulaire!: FormulaireInterface
    @Prop() reponsesFormulaire!: any
    @Prop({ default: true }) mode_demo!: boolean
    @Prop({ default: true }) mode_edit!: boolean
    @Prop({ default: false }) mode_lecture!: boolean
    @Prop({ default: true }) withDataDefault!: boolean
    @Prop({ default: true }) show_json!: boolean
    @Prop({ default: false }) check_validation!: boolean
    @Prop({ default: true }) visionneuse_enabled!: boolean
    @Prop() data_sup!: any | null;
    @Prop() user!: any
    @Prop() storeDocument!: Function | null
    @Prop() getDocument!: Function | null
    @Prop() deleteDocument!: Function | null
    @Prop() storeDocumentReference!: Function | null
    @Prop() getDocumentReference!: Function | null
    @Prop() deleteDocumentReference!: Function | null
    @Prop() scrollHandler!: Function | null
    @Prop() validationHandler!: Function | null
    
    json_value = ''
    json_structure = ''

    TypePartie = TypePartie
    getTypePartieSpec = getTypePartieSpec

    data_sup_temp: any = {
        pilote: {
            data: {
                _code: 'pilote',
                content:[{
                    libelle:'ADMISSIBILITÉ',
                    content: [{
                        libelle:'1- Epreuves écrites',
                        content: [
                            {
                                libelle:'11- Composition portant sur une question posée aujourd’hui à la société française dans ses dimensions judiciaires, juridiques, sociales, politiques, historiques, économiques, philosophiques et culturelles'
                            },
                            {
                                libelle:'12- Cas pratique sur un sujet de droit civil et de procédure civile'
                            },
                            {
                                libelle:'13- Cas pratique sur un sujet de droit pénal et de procédure pénale'
                            },
                            {
                                libelle:'14- Note de synthèse à partir de documents se raportant à des problèmes judiciaires, juridiques ou administratifs'
                            },
                            {
                                libelle:'15-Épreuve écrite au choix',
                                min: 1,
                                max: 2,
                                content: [
                                    {
                                        libelle: '1111 - Droit social',
                                        value: '1111',
                                        isDisabledIf: ['1111']
                                    },
                                    {
                                        libelle: '1112 - Droit des affaires',
                                        value: '1112',
                                        isDisabledIf: ['1112']
                                    },
                                    {
                                        libelle: '1113 - Droit des affaires Bis',
                                        value: '1113',
                                        isDisabledIf: ['1112', '1113']
                                    }
                                ]
                            }
                        ]
                    }
                    ]
                },
                {
                    libelle:'ADMISSION',
                    content: [
                        {
                            libelle:'1 - Epreuves orales',
                            content: [
                                {
                                    libelle: '11 - Epreuves obligatoires',
                                    content: [
                                        {
                                            libelle:  '111 - Série 1 (au choix)',
                                            min: 1,
                                            max: 1,
                                            content: [
                                                {
                                                    libelle: '1111 - Droit social',
                                                    value: '1111',
                                                    isDisabledIf: ['1111']
                                                },
                                                {
                                                    libelle: '1112 - Droit des affaires',
                                                    value: '1112',
                                                    isDisabledIf: ['1112', '1113']
                                                }
                                            ]
                                        },
                                        {
                                            libelle:  '112- Série 2',
                                            content: [
                                                {
                                                    libelle: '1121 - Droit public'
                                                },
                                                {
                                                    libelle: '1122 - Mise en situation et entretien avec le jury'
                                                }
                                            ]
                                        }
                                    ]

                                },
                                {
                                    libelle: ' 12 - Epreuve facultative',
                                    content: [
                                        {
                                            libelle:  '121 - Langue étrangère',
                                            min: 1,
                                            max: 4,
                                            content: [
                                                {
                                                    libelle: '1211 - Anglais facultatif',
                                                    value: '1211',
                                                    isDisabledIf: null
                                                },
                                                {
                                                    libelle: '1212 - Allemand facultatif',
                                                    value: '1212',
                                                    isDisabledIf: null
                                                },
                                                {
                                                    libelle: '1213 - Espagnol facultatif',
                                                    value: '1213',
                                                    isDisabledIf: null
                                                },
                                                {
                                                    libelle: '1214 - Italien facultatif',
                                                    value: '1214',
                                                    isDisabledIf: null
                                                },
                                                {
                                                    libelle: '1215 - Arabe littéral facultatif',
                                                    value: '1215',
                                                    isDisabledIf: null
                                                }
                                            ]
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }]
            }
        },
        concours: {
            data: {
                _code: 'concours',
                min: 1,
                max: 4,
                content: [
                    {
                        _id: 180,
                        _code: 'EPF-PC',
                        libelle: 'EPF Sceaux/Troyes/Montpellier PC',
                        value: 'EPF-PC',
                        content: []
                    },
                    {
                        _id: 184,
                        _code: 'Navale-PC',
                        libelle: 'école navale filière PC',
                        value: 'Navale-PC',
                        content: []
                    },
                    {
                        _id: 190,
                        _code: 'ENSEA-PC',
                        libelle: 'ENSEA filière PC',
                        value: 'ENSEA-PC',
                        content: []
                    },
                    {
                        _id: 224,
                        _code: 'CS-PC',
                        libelle: 'CentraleSupélec filière PC',
                        value: 'CS-PC',
                        content: []
                    }
                ]
            }
        }
        // [{ _id:48, _code:'EVC-18-A', libelle:'18-Gynécologie Obstétrique-Liste A', value:'EVC-18-A', content:[] }]
    }

    typeSelectData = {
        options: [
            {
                value: TypePartie.TYPE_MANUEL,
                libelle: getTypePartieSpec(TypePartie.TYPE_MANUEL).libelle,
                ordre: 1
            },
            {
                value: TypePartie.TYPE_AUTO,
                libelle: getTypePartieSpec(TypePartie.TYPE_AUTO).libelle,
                ordre: 2
            }
        ]
    }

    condition_champ_input_type_reponse = 1
    data_condition_type_reponse = { options :[{ value:  1, libelle:'renseigné', ordre: 1 }, { value: 2, libelle: 'renseigné et a pour valeur', ordre: 2 }] }
           
    typeInput = TypeInput
    modeDev = false

    mode_edit_from_dev = true
    mode_lecture_from_dev = false

    showModalEditionPartie = false
    showModalMessageDeletePartie  = false

    otherParties: Array<any> = []

    data_position_parties: any = null
    data_position_placement = { 
        options: [{
            value: 'before',
            libelle: 'Avant',
            ordre: 1
        },
        {
            value: 'after',
            libelle: 'Après',
            ordre: 2
        }]
    }

    showVisionneuse = false

    select_position_placement_default_value: any = null
    select_position_parties_default_value = -1

    forConditionSelectableInputs: any = null
    
    conditionInput: InputInterface | null  = null

    otherInputs: Array<any> = []

    formulaireDefault: FormulaireInterface = { 
        libelle:'INSCRIPTION AU CONCOURS DE DIRECTEUR D’ETABLISSEMENT SANITAIRE, SOCIAL ET MEDICO-SOCIAL', 
        description:'Le Centre National de Gestion ne validera l’inscription qu’à réception du dossier complété, signé et scanné (envoi par le biais de l’application d’inscription) avec l’ensemble des pièces demandées.', 
        parties:[
            {
                id:8,
                ref:'',
                type:1,
                libelle:'INSCRIPTION AU CONCOURS',
                description:'',
                ordre:0,
                value: null,
                inputs:[{ 
                    id:55, 
                    ref:'voie',
                    libelle:'VOIE',
                    ordre:0,
                    requis:true,
                    data:{ prompt:'', options:[{ value:1, libelle:'INTERNE', ordre:1 }, { value:2, libelle:'EXTERNE', ordre:2 }, { value:3, libelle:'TALENT', ordre:3 }, { value:4, libelle:'3ieme CONCOURS', ordre:4 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:56, 
                    ref:'centre_examen',
                    libelle:'CENTRE D’EXAMEN CHOISI',
                    ordre:1,
                    requis:true,
                    data:{ min:5, max:10 },
                    type:8,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'' 
                }, { 
                    id:71, 
                    libelle:'test date heure',
                    ref:'dateh',
                    ordre:2,
                    requis:false,
                    data:{ min:'2023-11-07T11:50', max:'2023-11-14T11:50' },
                    type:3,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'Cette date doit être égale ou antérieure au 14/11/2023 - 11:50.' 
                }, { 
                    id:72, 
                    libelle:'test choix unique',
                    ref:'testttt',
                    ordre:3,
                    requis:true,
                    data:{ prompt:'', options:[{ value:1, libelle:'option 1', ordre:1 }, { value:2, libelle:'option 2', ordre:2 }, { value:3, libelle:'option 3', ordre:3 }] },
                    type:6,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'' 
                }, { 
                    id:73, 
                    libelle:'test choix multiple',
                    ref:'cmulti',
                    ordre:4,
                    requis:false,
                    data:{ prompt:'', options:[{ value:1, libelle:'option 1', ordre:1 }, { value:2, libelle:'option 2', ordre:2 }, { value:3, libelle:'option 3', ordre:3 }] },
                    type:14,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'' 
                }, { 
                    id:74, 
                    libelle:'checkbox',
                    ref:'cb',
                    ordre:5,
                    requis:false,
                    data:{},
                    type:1,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'' 
                }],
                condition:null,
                data:null 
            }, { 
                id:1, 
                ref:'etat_civil',
                type:1,
                libelle:'ETAT-CIVIL',
                description:'',
                ordre:1,
                value: null,
                inputs:[{ 
                    id:1, 
                    ref:'',
                    libelle:'Civilité',
                    description:'',
                    ordre:0,
                    requis:true,
                    data:{ prompt:'', options:[{ value:1, libelle:'Monsieur', ordre:1 }, { value:2, libelle:'Madame', ordre:2 }] },
                    type:7,
                    condition:null,
                    value:null 
                }, { 
                    id:2, 
                    ref:'user.name',
                    libelle:'Nom usuel',
                    description:'',
                    ordre:1,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null 
                }, { 
                    id:3, 
                    ref:'birth_name',
                    libelle:'Nom de naissance',
                    description:'',
                    ordre:2,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null 
                }, { 
                    id:4, 
                    ref:'first_name',
                    libelle:'Prénom usuel',
                    description:'',
                    ordre:3,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null 
                }, { 
                    id:5, 
                    ref:'first_name_bis',
                    libelle:'Autre prénoms',
                    description:'',
                    ordre:4,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null 
                }, { 
                    id:15,
                    ref:'date_n',
                    libelle:'Date de naissance',
                    ordre:5,
                    requis:true,
                    data:{ min:null, max:'2010-01-01' },
                    type:2,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'Cette date doit être égale ou postérieure au 01/01/1930.' 
                }, { 
                    id:16, 
                    ref:'departement_n',
                    libelle:'Département de naissance',
                    ordre:6,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:17, 
                    ref:'ville_n',
                    libelle:'Ville de naissance',
                    ordre:7,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:18, 
                    ref:'pays_n',
                    libelle:'Pays de naissance',
                    ordre:8,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:19, 
                    ref:'situation_familiale',
                    libelle:'Situation familiale',
                    ordre:9,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:47, 
                    ref:'handicap',
                    libelle:'Etes-vous reconnu(e) personne handicapée ?',
                    ordre:10,
                    requis:true,
                    data:{ prompt:'', options:[{ value:1, libelle:'Oui', ordre:1 }, { value:2, libelle:'Non', ordre:2 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:48, 
                    ref:'amenagement',
                    libelle:'Souhaitez-vous un aménagement d’épreuves ?',
                    ordre:11,
                    requis:true,
                    data:{ prompt:'', options:[{ value:1, libelle:'Oui', ordre:1 }, { value:2, libelle:'Non', ordre:2 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }],
                condition:{ champ_id:56, value:'123456' },
                data:null 
            }, { 
                id:3,
                ref:'',
                type:1,
                libelle:'ADRESSE POSTALE',
                description:'',
                value: null,
                ordre:2,
                inputs:[{ 
                    id:21, 
                    ref:'adresse',
                    libelle:'Adresse',
                    ordre:0,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:22, 
                    ref:'adresse_suite',
                    libelle:'Adresse (suite)',
                    ordre:1,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:23, 
                    ref:'adresse_comp',
                    libelle:'Complément d’adresse',
                    ordre:2,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:24, 
                    ref:'code_postal',
                    libelle:'Code postal',
                    ordre:3,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:25, 
                    ref:'ville',
                    libelle:'Ville',
                    ordre:4,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:26, 
                    ref:'arrondissement',
                    libelle:'Arrondissement obligatoire pour Lyon, Marseille et Paris',
                    ordre:5,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:27, 
                    ref:'pays',
                    libelle:'Pays de résidence',
                    ordre:6,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:28,
                    ref:'telephone',
                    libelle:'Téléphone domicile',
                    ordre:7,
                    requis:true,
                    data:{},
                    type:10,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'' 
                }, { 
                    id:29, 
                    ref:'telephone_pro',
                    libelle:'Téléphone professionnel',
                    ordre:8,
                    requis:false,
                    data:{},
                    type:10,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'Le format du numéro de téléphone est incorrect.' 
                }, { 
                    id:30, 
                    ref:'telephone_mobile',
                    libelle:'Téléphone mobile',
                    ordre:9,
                    requis:false,
                    data:{},
                    type:10,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'Le format du numéro de téléphone est incorrect.' 
                }, { 
                    id:31, 
                    ref:'user.email',
                    libelle:'Adresse électronique personnelle',
                    ordre:10,
                    requis:true,
                    data:{},
                    type:15,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:'' 
                }],
                condition:null,
                data:null 
            }, { 
                id:4, 
                ref:'',
                type:1,
                libelle:'NATIONALITE',
                description:'',
                ordre:3,
                value: null,
                inputs:[{ 
                    id:32, 
                    ref:'nationalite_fr',
                    libelle:'Etes-vous de nationalité  française',
                    ordre:0,
                    requis:true,
                    data:{ prompt:'', options:[{ value:1, libelle:'Oui', ordre:1 }, { value:2, libelle:'Non', ordre:2 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:33, 
                    ref:'nationalite',
                    libelle:'Si non, quelle est votre nationalité ?',
                    ordre:1,
                    requis:true,
                    data:{},
                    type:8,
                    condition:{ champ_id:32, value:'2' },
                    value:null,
                    description:'' 
                }],
                condition:null,
                data:null 
            }, { 
                id:5, 
                ref:'',
                type:1,
                libelle:'AUTRES INFORMATIONS',
                description:'',
                value: null,
                ordre:4,
                inputs:[{ 
                    id:34, 
                    ref:'employeur',
                    libelle:'Etablissement employeur',
                    ordre:0,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:35, 
                    ref:'employeur_adresse',
                    libelle:'Adresse',
                    ordre:1,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:36, 
                    ref:'employeur_adresse_suite',
                    libelle:'Adresse (suite)',
                    ordre:2,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:37, 
                    ref:'employeur_adresse_comp',
                    libelle:'Complément d’adresse',
                    ordre:3,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:38, 
                    ref:'employeur_code_postal',
                    libelle:'Code postal',
                    ordre:4,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:39, 
                    ref:'employeur_ville',
                    libelle:'Ville',
                    ordre:5,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:40, 
                    ref:'employeur_grade',
                    libelle:'Grade, emploi',
                    ordre:6,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:41, 
                    ref:'employeur_qualite',
                    libelle:'Qualité',
                    ordre:7,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:42, 
                    ref:'employeur_fonction',
                    libelle:'Fonctions occupées',
                    ordre:8,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:43, 
                    ref:'employeur_date_entre',
                    libelle:'Date d’entrée dans la fonction publique',
                    ordre:9,
                    requis:false,
                    data:{ min:'1930-01-01', max:'2024-01-01' },
                    type:2,
                    condition:null,
                    value:null,
                    description:'Pour le calcul de votre ancienneté au 31 décembre 2023',
                    anomalie:'' 
                }, { 
                    id:44, 
                    ref:'last_diplome',
                    libelle:'Quel est votre diplôme le plus élevé ?',
                    ordre:10,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:45, 
                    ref:'preparation_concour',
                    libelle:'Avez-vous suivi une préparation au concours ?',
                    ordre:11,
                    requis:false,
                    data:{ prompt:'', options:[{ value:1, libelle:'Oui', ordre:1 }, { value:2, libelle:'Non', ordre:2 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:46, 
                    ref:'preparation_details',
                    libelle:'Si oui, laquelle',
                    ordre:12,
                    requis:false,
                    data:{},
                    type:8,
                    condition:{ champ_id:'45', value:'1' },
                    value:null,
                    description:'' 
                }, { 
                    id:57, 
                    ref:'deja_presente',
                    libelle:'Vous êtes-vous déjà présenté(e) au concours de directeur d’établissement, sanitaire, social et médico-social ?',
                    ordre:13,
                    requis:false,
                    data:{ prompt:'', options:[{ value:1, libelle:'Oui', ordre:1 }, { value:2, libelle:'Non', ordre:2 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'Externe' 
                }, { 
                    id:58, 
                    ref:'nbre_presentation',
                    libelle:'Si oui, combien de fois ?',
                    ordre:14,
                    requis:false,
                    data:{ min:'1', max:'10', step:'1' },
                    type:12,
                    condition:{ champ_id:'57', value:'1' },
                    value:null,
                    description:'Ne sont comptabilisées que les années  où vous vous êtes présenté(e) à au moins une épreuve écrite d’admissibilité' 
                }, { 
                    id:59, 
                    ref:'annees_presentation',
                    libelle:'Année(s) ?',
                    ordre:15,
                    requis:false,
                    data:{},
                    type:8,
                    condition:{ champ_id:'57', value:'1' },
                    value:null,
                    description:'' 
                }, { 
                    id:60, 
                    ref:'boursier',
                    libelle:'Etes-vous boursier de l’enseignement supérieur ?',
                    ordre:16,
                    requis:false,
                    data:{ prompt:'', options:[{ value:1, libelle:'Oui', ordre:1 }, { value:2, libelle:'Non', ordre:2 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'Externe, talent' 
                }, { 
                    id:66, 
                    ref:'residence',
                    libelle:'Votre lieu de résidence habituel relève',
                    ordre:17,
                    requis:false,
                    data:{ prompt:'', options:[{ value:1, libelle:'d’une collectivité, d’un département ou d’une région d’outre-mer', ordre:1 }, { value:2, libelle:'d’une zone de revitalisation rurale (ZRR)', ordre:2 }, { value:3, libelle:'d’une zone urbaine identifiée au titre de la revalorisation des quartiers prioritaires de la politique de la ville', ordre:3 }, { value:4, libelle:'Autre', ordre:4 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'talent' 
                }, { 
                    id:67, 
                    ref:'prepa_talent',
                    libelle:'Etablissement PREPA TALENTS suivie',
                    ordre:18,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'Talent' 
                }, { 
                    id:69, 
                    ref:'periode_prepa_talent',
                    libelle:'A quelle période ?',
                    ordre:19,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'Talent' 
                }, { 
                    id:70, 
                    ref:'choix_admission',
                    libelle:'Choix en cas d’admission',
                    ordre:20,
                    requis:false,
                    data:{ prompt:'', options:[{ value:1, libelle:'Concours externe', ordre:1 }, { value:2, libelle:'Concours externe spécial', ordre:2 }] },
                    type:7,
                    condition:null,
                    value:null,
                    description:'Talent' 
                }],
                condition:null,
                data:null 
            }, { 
                id:7, 
                ref:'',
                type:1,
                libelle:'PIECES JUSTIFICATIVES',
                description:'',
                ordre:5,
                value: null,
                inputs:[{ 
                    id:53, 
                    ref:'photo_ident',
                    libelle:'Photo  d’identité',
                    ordre:0,
                    requis:false,
                    data:{ min:1, max:25 },
                    type:5,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:49, 
                    ref:'service_civils',
                    libelle:'L’état des services civils accomplis',
                    ordre:1,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'interne' 
                }, { 
                    id:50, 
                    ref:'dernier_contrat_contractuel',
                    libelle:'La copie du dernier contrat de travail pour les contractuels',
                    ordre:2,
                    requis:false,
                    data:{ min:1, max:5 },
                    type:5,
                    condition:null,
                    value:null,
                    description:'interne' 
                }, { 
                    id:51, 
                    ref:'piece_ident',
                    libelle:'La copie d’une pièce d’identité (recto/verso) ',
                    ordre:3,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'interne' 
                }, { 
                    id:52, 
                    ref:'avis_handicap',
                    libelle:'Candidat en situation de handicap : joindre un avis de la Maison Départementale des Personnes Handicapées compétente, ainsi qu’un certificat d’un médecin agréé précisant le cas échéant la nécessité d’adapter les épreuves (1/3 temps, agrandissement des suj',
                    ordre:4,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'Candidat en situation de handicap : joindre un avis de la Maison Départementale des Personnes Handicapées compétente, ainsi qu’un certificat d’un médecin agréé précisant le cas échéant la nécessité d’adapter les épreuves (1/3 temps, agrandissement des sujets…)' 
                }, { 
                    id:54, 
                    ref:'copie_diplome',
                    libelle:'La copie du diplôme permettant de se présenter au concours (pour les diplômes étrangers : demander une équivalence au Centre international d’Etudes Pédagogiques ENIC-NARIC)',
                    ordre:5,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'externe' 
                }, { 
                    id:61, 
                    ref:'recap_mandats',
                    libelle:"L'état récapitulatif des mandats ou exercices d’activités privées ou associatives (imprimé joint) ",
                    ordre:6,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'3ieme' 
                }, { 
                    id:62, 
                    ref:'contrats_travail',
                    libelle:'La copie du ou des contrats de travail',
                    ordre:7,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'3ieme' 
                }, { 
                    id:63, 
                    ref:'releve_carriere',
                    libelle:'La copie du relevé de carrière (service de retraite)',
                    ordre:8,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'3ieme' 
                }, { 
                    id:64, 
                    ref:'copie_diplome_bis',
                    libelle:'La copie du diplôme permettant de se présenter au concours (pour les diplômes étrangers : demander une équivalence au Centre international d’Etudes Pédagogiques ENIC-NARIC)',
                    ordre:9,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'talent' 
                }, { 
                    id:65, 
                    ref:'attestation_suiviformation_externe_spe',
                    libelle:'Une attestation de suivi d’un cycle de formation au concours externe spécial d’accès à certaines écoles de service public (titre I et article 4 du décret n° 2021-239 du 3 mars 2021 modifié). Cette attestation doit être établie sur le modèle téléchargeable',
                    ordre:10,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'talent' 
                }],
                condition:null,
                data:null 
            }, { 
                id:9, 
                ref:'concours',
                type:2,
                libelle:'Concours',
                description:'',
                ordre:6,
                inputs:[],
                condition:null,
                value: null,
                data:{ 
                    data:{ 
                        _code:'concours',
                        min:1,
                        max:3,
                        content:[{ 
                            _id:180, 
                            _code:'EPF-PC',
                            libelle:'EPF Sceaux/Troyes/Montpellier PC',
                            value:'EPF-PC',
                            content:[] 
                        }, { 
                            _id:184, 
                            _code:'Navale-PC',
                            libelle:'école navale filière PC',
                            value:'Navale-PC',
                            content:[] 
                        }, { 
                            _id:190, 
                            _code:'ENSEA-PC',
                            libelle:'ENSEA filière PC',
                            value:'ENSEA-PC',
                            content:[] 
                        }, { 
                            _id:224, 
                            _code:'CS-PC',
                            libelle:'CentraleSupélec filière PC',
                            value:'CS-PC',
                            content:[] 
                        }] 
                    } 
                } 
            }, { 
                id:10, 
                ref:'pilote',
                type:2,
                libelle:'pilote',
                description:'',
                ordre:7,
                inputs:[],
                condition:null,
                value: null,
                data:{ 
                    data:{ 
                        _code:'pilote', 
                        content:[{ 
                            libelle:'ADMISSIBILITÉ', 
                            content:[{ 
                                libelle:'1- Epreuves écrites', 
                                content:[{ 
                                    libelle:'11- Composition portant sur une question posée aujourd’hui à la société française dans ses dimensions judiciaires, juridiques, sociales, politiques, historiques, économiques, philosophiques et culturelles' 
                                }, { 
                                    libelle:'12- Cas pratique sur un sujet de droit civil et de procédure civile' 
                                }, { libelle:'13- Cas pratique sur un sujet de droit pénal et de procédure pénale' }, { libelle:'14- Note de synthèse à partir de documents se raportant à des problèmes judiciaires, juridiques ou administratifs' }, {
                                    libelle:'15-Épreuve écrite au choix', 
                                    min:1, 
                                    max:2,
                                    content:[{ 
                                        libelle:'1111 - Droit social', 
                                        value:'1111', 
                                        isDisabledIf:['1111'] 
                                    }, { 
                                        libelle:'1112 - Droit des affaires', 
                                        value:'1112', 
                                        isDisabledIf:['1112'] 
                                    }, { 
                                        libelle:'1113 - Droit des affaires Bis', 
                                        value:'1113', 
                                        isDisabledIf:['1112', '1113'] 
                                    }] 
                                }] 
                            }] 
                        }, { 
                            libelle:'ADMISSION', 
                            content:[{ 
                                libelle:'1 - Epreuves orales', 
                                content:[{ 
                                    libelle:'11 - Epreuves obligatoires', 
                                    content:[{ 
                                        libelle:'111 - Série 1 (au choix)', 
                                        min:1,
                                        max:1,
                                        content:[{ 
                                            libelle:'1111 - Droit social', 
                                            value:'1111', 
                                            isDisabledIf:['1111'] 
                                        }, { 
                                            libelle:'1112 - Droit des affaires', 
                                            value:'1112',
                                            isDisabledIf:['1112', '1113'] 
                                        }] 
                                    }, { 
                                        libelle:'112- Série 2', 
                                        content:[{ 
                                            libelle:'1121 - Droit public' 
                                        }, { 
                                            libelle:'1122 - Mise en situation et entretien avec le jury' 
                                        }] 
                                    }] 
                                }, { 
                                    libelle:' 12 - Epreuve facultative', 
                                    content:[{ 
                                        libelle:'121 - Langue étrangère', 
                                        min:2, 
                                        max:4, 
                                        content:[{ 
                                            libelle:'1211 - Anglais facultatif', 
                                            value:'1211', 
                                            isDisabledIf:null 
                                        }, { 
                                            libelle:'1212 - Allemand facultatif', 
                                            value:'1212', 
                                            isDisabledIf:null 
                                        }, { 
                                            libelle:'1213 - Espagnol facultatif',
                                            value:'1213', 
                                            isDisabledIf:null 
                                        }, { 
                                            libelle:'1214 - Italien facultatif', 
                                            value:'1214', 
                                            isDisabledIf:null 
                                        }, { 
                                            libelle:'1215 - Arabe littéral facultatif', 
                                            value:'1215',
                                            isDisabledIf:null 
                                        }] 
                                    }] 
                                }] 
                            }] 
                        }] 
                    } 
                } 
            }] 
    }

    formulaireDefaultB: FormulaireInterface = {
        libelle:'INSCRIPTION AU CONCOURS DE DIRECTEUR D’ETABLISSEMENT SANITAIRE, SOCIAL ET MEDICO-SOCIAL',
        description:'Le Centre National de Gestion ne validera l’inscription qu’à réception du dossier complété, signé et scanné (envoi par le biais de l’application d’inscription) avec l’ensemble des pièces demandées.',
        parties:[
            { 
                id:8, 
                ref:'',
                type: TypePartie.TYPE_MANUEL,
                data: null,
                value: null,
                libelle:'INSCRIPTION AU CONCOURS',
                description:'',
                ordre:0,
                inputs:[{ 
                    id:55, 
                    ref: 'voie',
                    libelle:'VOIE',
                    ordre:0,
                    requis:true,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'INTERNE', ordre:1 }, 
                            { value:2, libelle:'EXTERNE', ordre:2 }, 
                            { value:3, libelle:'TALENT', ordre:3 }, 
                            { value:4, libelle:'3ieme CONCOURS', ordre:4 }] 
                    },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:56, 
                    ref: 'centre_examen',
                    libelle:'CENTRE D’EXAMEN CHOISI',
                    ordre:1,
                    requis:true,
                    data:{ min:5, max:10 },
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, {
                    id:71,
                    libelle:'test date heure',
                    ref:'dateh',
                    ordre:2,
                    requis:false,
                    data:{
                        min:'2023-11-07T11:50',
                        max:'2023-11-14T11:50'
                    },
                    type:3,
                    condition:null,
                    value:null,
                    description:'',
                    anomalie:''
                }],
                condition:null 
            }, { 
                id:1, 
                ref:'etat_civil',
                type: TypePartie.TYPE_MANUEL,
                data: null,
                value: null,
                libelle:'ETAT-CIVIL',
                description:'',
                ordre:1,
                inputs:[{ 
                    id:1, 
                    ref: '',
                    libelle:'Civilité',
                    description:'',
                    ordre:0,
                    requis:true,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'Monsieur', ordre:1 }, 
                            { value:2, libelle:'Madame', ordre:2 }] 
                    },
                    type:7,
                    condition:null,
                    value:null 
                }, { 
                    id:2, 
                    ref: 'user.name',
                    libelle:'Nom usuel', 
                    description:'',
                    ordre:1,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:'' 
                }, { 
                    id:3, 
                    ref: 'birth_name',
                    libelle:'Nom de naissance', 
                    description:'',
                    ordre:2,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null 
                }, { 
                    id:4, 
                    ref: 'first_name',
                    libelle:'Prénom usuel', 
                    description:'',
                    ordre:3,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null 
                }, { 
                    id:5, 
                    ref: 'first_name_bis',
                    libelle:'Autre prénoms', 
                    description:'',
                    ordre:4,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null 
                }, { 
                    id:15, 
                    ref: 'date_n',
                    libelle:'Date de naissance',
                    ordre:5,
                    requis:true,
                    data:{ min:'1930-01-01', max:'2010-01-01' },
                    type:2,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:16, 
                    ref: 'departement_n',
                    libelle:'Département de naissance',
                    ordre:6,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:17, 
                    ref: 'ville_n',
                    libelle:'Ville de naissance',
                    ordre:7,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:18, 
                    ref: 'pays_n',
                    libelle:'Pays de naissance',
                    ordre:8,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:19, 
                    ref: 'situation_familiale',
                    libelle:'Situation familiale',
                    ordre:9,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:47, 
                    ref: 'handicap',
                    libelle:'Etes-vous reconnu(e) personne handicapée ?',
                    ordre:10,
                    requis:true,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'Oui', ordre:1 }, 
                            { value:2, libelle:'Non', ordre:2 }] 
                    },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:48, 
                    ref: 'amenagement',
                    libelle:'Souhaitez-vous un aménagement d’épreuves ?',
                    ordre:11,
                    requis:true,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'Oui', ordre:1 }, 
                            { value:2, libelle:'Non', ordre:2 }] 
                    },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }],
                condition:null 
            }, { 
                id:3, 
                ref:'',
                type: TypePartie.TYPE_MANUEL,
                data: null,
                value: null,
                libelle:'ADRESSE POSTALE',
                description:'',
                ordre:2,
                inputs:[{ 
                    id:21, 
                    ref: 'adresse',
                    libelle:'Adresse',
                    ordre:0,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:22, 
                    ref: 'adresse_suite',
                    libelle:'Adresse (suite)',
                    ordre:1,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:23, 
                    ref: 'adresse_comp',
                    libelle:'Complément d’adresse',
                    ordre:2,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:24, 
                    ref: 'code_postal',
                    libelle:'Code postal',
                    ordre:3,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:25, 
                    ref: 'ville',
                    libelle:'Ville',
                    ordre:4,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:26, 
                    ref: 'arrondissement',
                    libelle:'Arrondissement obligatoire pour Lyon, Marseille et Paris',
                    ordre:5,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:27, 
                    ref: 'pays',
                    libelle:'Pays de résidence',
                    ordre:6,
                    requis:true,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:28, 
                    ref: 'telephone',
                    libelle:'Téléphone domicile',
                    ordre:7,
                    requis:true,
                    data:{},
                    type:10,
                    condition:null,
                    value:'',
                    description:'' 
                }, { 
                    id:29, 
                    ref: 'telephone_pro',
                    libelle:'Téléphone professionnel',
                    ordre:8,
                    requis:false,
                    data:{},
                    type:10,
                    condition:null,
                    value:'',
                    description:'' 
                }, { 
                    id:30, 
                    ref: 'telephone_mobile',
                    libelle:'Téléphone mobile',
                    ordre:9,
                    requis:false,
                    data:{},
                    type:10,
                    condition:null,
                    value:'',
                    description:'' 
                }, { 
                    id:31, 
                    ref: 'email',
                    libelle:'Adresse électronique personnelle',
                    ordre:10,
                    requis:true,
                    data:{},
                    type:15,
                    condition:null,
                    value:null,
                    description:'' 
                }],
                condition:null 
            }, { 
                id:4, 
                ref:'',
                type: TypePartie.TYPE_MANUEL,
                data: null,
                value: null,
                libelle:'NATIONALITE',
                description:'',
                ordre:3,
                inputs:[{ 
                    id:32, 
                    ref: 'nationalite_fr',
                    libelle:'Etes-vous de nationalité  française', 
                    ordre:0,
                    requis:true,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'Oui', ordre:1 }, 
                            { value:2, libelle:'Non', ordre:2 }] 
                    },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:33, 
                    ref: 'nationalite',
                    libelle:'Si non, quelle est votre nationalité ?',
                    ordre:1,
                    requis:false,
                    data:{},
                    type:8,
                    condition:{ champ_id:32, value:'2' },
                    value:null,
                    description:'' 
                }],
                condition:null 
            }, { 
                id:5, 
                ref:'',
                type: TypePartie.TYPE_MANUEL,
                data: null,
                value: null,
                libelle:'AUTRES INFORMATIONS', 
                description:'',
                ordre:4,
                inputs:[{ 
                    id:34, 
                    ref: 'employeur',
                    libelle:'Etablissement employeur',
                    ordre:0,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:35, 
                    ref: 'employeur_adresse',
                    libelle:'Adresse',
                    ordre:1,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:36, 
                    ref: 'employeur_adresse_suite',
                    libelle:'Adresse (suite)',
                    ordre:2,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:37, 
                    ref: 'employeur_adresse_comp',
                    libelle:'Complément d’adresse',
                    ordre:3,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:38, 
                    ref: 'employeur_code_postal',
                    libelle:'Code postal',
                    ordre:4,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:39, 
                    ref: 'employeur_ville',
                    libelle:'Ville', 
                    ordre:5,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:40,
                    ref: 'employeur_grade', 
                    libelle:'Grade, emploi', 
                    ordre:6,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:41, 
                    ref: 'employeur_qualite',
                    libelle:'Qualité', 
                    ordre:7,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:42, 
                    ref: 'employeur_fonction',
                    libelle:'Fonctions occupées', 
                    ordre:8,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:43, 
                    ref: 'employeur_date_entre',
                    libelle:'Date d’entrée dans la fonction publique',
                    ordre:9,
                    requis:false,
                    data:{ min:'1930-01-01', max:'2024-01-01' },
                    type:2,
                    condition:null,
                    value:null,
                    description:'Pour le calcul de votre ancienneté au 31 décembre 2023' 
                }, { 
                    id:44, 
                    ref: 'last_diplome',
                    libelle:'Quel est votre diplôme le plus élevé ?',
                    ordre:10,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:45, 
                    ref: 'preparation_concour',
                    libelle:'Avez-vous suivi une préparation au concours ?',
                    ordre:11,
                    requis:false,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'Oui', ordre:1 }, 
                            { value:2, libelle:'Non', ordre:2 }] 
                    },
                    type:7,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:46, 
                    ref: 'preparation_details',
                    libelle:'Si oui, laquelle',
                    ordre:12,
                    requis:false,
                    data:{},
                    type:8,
                    condition:{ champ_id:'45', value:'1' },
                    value:null,
                    description:'' 
                }, { 
                    id:57, 
                    ref: 'deja_presente',
                    libelle:'Vous êtes-vous déjà présenté(e) au concours de directeur d’établissement, sanitaire, social et médico-social ?',
                    ordre:13,
                    requis:false,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'Oui', ordre:1 }, 
                            { value:2, libelle:'Non', ordre:2 }] 
                    },
                    type:7,
                    condition:{ champ_id:null, value:null },
                    value:null,
                    description:'Externe' 
                }, { 
                    id:58, 
                    ref: 'nbre_presentation',
                    libelle:'Si oui, combien de fois ?',
                    ordre:14,
                    requis:false,
                    data:{ min:'1', max:'10', step:'1' },
                    type:12,
                    condition:{ champ_id:'57', value:'1' },
                    value:null,
                    description:'Ne sont comptabilisées que les années  où vous vous êtes présenté(e) à au moins une épreuve écrite d’admissibilité' 
                }, { 
                    id:59, 
                    ref: 'annees_presentation',
                    libelle:'Année(s) ?', 
                    ordre:15,
                    requis:false,
                    data:{},
                    type:8,
                    condition:{ champ_id:'57', value:'1' },
                    value:null,
                    description:'' 
                }, { 
                    id:60, 
                    ref: 'boursier',
                    libelle:'Etes-vous boursier de l’enseignement supérieur ?',
                    ordre:16,
                    requis:false,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'Oui', ordre:1 }, 
                            { value:2, libelle:'Non', ordre:2 }] 
                    },
                    type:7,
                    condition:null,
                    value:null,
                    description:'Externe, talent' 
                }, { 
                    id:66, 
                    ref: 'residence',
                    libelle:'Votre lieu de résidence habituel relève',
                    ordre:17,
                    requis:false,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'d’une collectivité, d’un département ou d’une région d’outre-mer', ordre:1 }, 
                            { value:2, libelle:'d’une zone de revitalisation rurale (ZRR)', ordre:2 }, 
                            { value:3, libelle:'d’une zone urbaine identifiée au titre de la revalorisation des quartiers prioritaires de la politique de la ville', ordre:3 }, 
                            { value:4, libelle:'Autre', ordre:4 }] 
                    },
                    type:7,
                    condition:null,
                    value:null,
                    description:'talent' 
                }, { 
                    id:67, 
                    ref: 'prepa_talent',
                    libelle:'Etablissement PREPA TALENTS suivie',
                    ordre:18,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'Talent' 
                }, { 
                    id:69, 
                    ref: 'periode_prepa_talent',
                    libelle:'A quelle période ?',
                    ordre:19,
                    requis:false,
                    data:{},
                    type:8,
                    condition:null,
                    value:null,
                    description:'Talent' 
                }, { 
                    id:70,
                    ref: 'choix_admission',
                    libelle:'Choix en cas d’admission', 
                    ordre:20,
                    requis:false,
                    data:{ 
                        prompt:'', 
                        options:[
                            { value:1, libelle:'Concours externe', ordre:1 }, 
                            { value:2, libelle:'Concours externe spécial', ordre:2 }] 
                    },
                    type:7,
                    condition:null,
                    value:null,
                    description:'Talent' 
                }],
                condition:null 
            }, { 
                id:6, 
                ref:'',
                type: TypePartie.TYPE_MANUEL,
                data: null,
                value: null,
                libelle:'EPREUVES DU CONCOURS', 
                description:'',
                ordre:5,
                inputs:[],
                condition:null 
            }, { 
                id:7, 
                ref:'',
                type: TypePartie.TYPE_MANUEL,
                data: null,
                value: null,
                libelle:'PIECES JUSTIFICATIVES', 
                description:'',
                ordre:6,
                inputs:[{ 
                    id:53, 
                    ref: 'photo_ident',
                    libelle:'Photo  d’identité',
                    ordre:0,
                    requis:true,
                    data:{ min: 1, max: 25 },
                    type:5,
                    condition:null,
                    value:null,
                    description:'' 
                }, { 
                    id:49, 
                    ref: 'service_civils',
                    libelle:'L’état des services civils accomplis',
                    ordre:1,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'interne' 
                }, { 
                    id:50, 
                    ref: 'dernier_contrat_contractuel',
                    libelle:'La copie du dernier contrat de travail pour les contractuels',
                    ordre:2,
                    requis:false,
                    data:{ min: 1, max: 5 },
                    type:5,
                    condition:null,
                    value:null,
                    description:'interne' 
                }, { 
                    id:51, 
                    ref: 'piece_ident',
                    libelle:'La copie d’une pièce d’identité (recto/verso) ',
                    ordre:3,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'interne' 
                }, { 
                    id:52, 
                    ref: 'avis_handicap',
                    libelle:'Candidat en situation de handicap : joindre un avis de la Maison Départementale des Personnes Handicapées compétente, ainsi qu’un certificat d’un médecin agréé précisant le cas échéant la nécessité d’adapter les épreuves (1/3 temps, agrandissement des suj',
                    ordre:4,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'Candidat en situation de handicap : joindre un avis de la Maison Départementale des Personnes Handicapées compétente, ainsi qu’un certificat d’un médecin agréé précisant le cas échéant la nécessité d’adapter les épreuves (1/3 temps, agrandissement des sujets…)' 
                }, { 
                    id:54, 
                    ref: 'copie_diplome',
                    libelle:'La copie du diplôme permettant de se présenter au concours (pour les diplômes étrangers : demander une équivalence au Centre international d’Etudes Pédagogiques ENIC-NARIC)',
                    ordre:5,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'externe' 
                }, { 
                    id:61, 
                    ref: 'recap_mandats',
                    libelle:"L'état récapitulatif des mandats ou exercices d’activités privées ou associatives (imprimé joint) ",
                    ordre:6,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'3ieme' 
                }, { 
                    id:62, 
                    ref: 'contrats_travail',
                    libelle:'La copie du ou des contrats de travail',
                    ordre:7,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'3ieme' 
                }, { 
                    id:63, 
                    ref: 'releve_carriere',
                    libelle:'La copie du relevé de carrière (service de retraite)',
                    ordre:8,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'3ieme' 
                }, { 
                    id:64, 
                    ref: 'copie_diplome_bis',
                    libelle:'La copie du diplôme permettant de se présenter au concours (pour les diplômes étrangers : demander une équivalence au Centre international d’Etudes Pédagogiques ENIC-NARIC)',
                    ordre:9,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'talent' 
                }, { 
                    id:65, 
                    ref: 'attestation_suiviformation_externe_spe',
                    libelle:'Une attestation de suivi d’un cycle de formation au concours externe spécial d’accès à certaines écoles de service public (titre I et article 4 du décret n° 2021-239 du 3 mars 2021 modifié). Cette attestation doit être établie sur le modèle téléchargeable',
                    ordre:10,
                    requis:false,
                    data:{},
                    type:5,
                    condition:null,
                    value:null,
                    description:'talent' 
                }],
                condition:null 
            }, { 
                id:9, 
                ref: 'epreuve',
                type: TypePartie.TYPE_AUTO,
                data:[
                    {
                        libelle:'ADMISSIBILITÉ',
                        content: [
                            {
                                libelle:'1- Epreuves écrites',
                                content: [
                                    {
                                        libelle:'11- Composition portant sur une question posée aujourd’hui à la société française dans ses dimensions judiciaires, juridiques, sociales, politiques, historiques, économiques, philosophiques et culturelles',
                                        content: [
                        
                                        ]
                                    },
                                    {
                                        libelle:'12- Cas pratique sur un sujet de droit civil et de procédure civile',
                                        content: [
                        
                                        ]
                                    },
                                    {
                                        libelle:'13- Cas pratique sur un sujet de droit pénal et de procédure pénale',
                                        content: [
                        
                                        ]
                                    },
                                    {
                                        libelle:'14- Note de synthèse à partir de documents se raportant à des problèmes judiciaires, juridiques ou administratifs',
                                        content: [
                        
                                        ]
                                    },
                                    {
                                        libelle:'15-Épreuve écrite au choix',
                                        content: [
                                            {
                                                libelle: '1111 - Droit social',
                                                value: '1111',
                                                isDisabledIf: ['1111']
                                            },
                                            {
                                                libelle: '1112 - Droit des affaires',
                                                value: '1112',
                                                isDisabledIf: ['1112']
                                            },
                                            {
                                                libelle: '1113 - Droit des affaires Bis',
                                                value: '1113',
                                                isDisabledIf: ['1112', '1113']
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        libelle:'ADMISSION',
                        content: [
                            {
                                libelle:'1 - Epreuves orales',
                                content: [
                                    {
                                        libelle: '11 - Epreuves obligatoires',
                                        content: [
                                            {
                                                libelle:  '111 - Série 1 (au choix)',
                                                content: [
                                                    {
                                                        libelle: '1111 - Droit social',
                                                        value: '1111',
                                                        isDisabledIf: ['1111']
                                                    },
                                                    {
                                                        libelle: '1112 - Droit des affaires',
                                                        value: '1112',
                                                        isDisabledIf: ['1112', '1113']
                                                    }
                                                ]
                                            },
                                            {
                                                libelle:  '112- Série 2',
                                                content: [
                                                    {
                                                        libelle: '1121 - Droit public'
                                                    },
                                                    {
                                                        libelle: '1122 - Mise en situation et entretien avec le jury'
                                                    }
                                                ]
                                            }
                                        ]

                                    },
                                    {
                                        libelle: ' 12 - Epreuve facultative',
                                        content: [
                                            {
                                                libelle:  '121 - Langue étrangère',
                                                content: [
                                                    {
                                                        libelle: '1211 - Anglais facultatif',
                                                        value: '1211',
                                                        isDisabledIf: null
                                                    },
                                                    {
                                                        libelle: '1212 - Allemand facultatif',
                                                        value: '1212',
                                                        isDisabledIf: null
                                                    },
                                                    {
                                                        libelle: '1213 - Espagnol facultatif',
                                                        value: '1213',
                                                        isDisabledIf: null
                                                    },
                                                    {
                                                        libelle: '1214 - Italien facultatif',
                                                        value: '1214',
                                                        isDisabledIf: null
                                                    },
                                                    {
                                                        libelle: '1215 - Arabe littéral facultatif',
                                                        value: '1215',
                                                        isDisabledIf: null
                                                    }
                                                ]
                                            }
                                        ]

                                    }
                                ]
                            }
                        ]
                    }
                ],
                value: null,
                libelle:'Épreuve(s) du 2ème concours d\'accès à l\'ENM 2023', 
                description:'',
                ordre:7,
                inputs:[],
                condition:null 
            }]
    }

    test_validation = false

    reponsesFormulaireDefaut: any = [{
        type:'input',
        ref:'voie',
        id:55,
        value:'2'
    }, { 
        type:'input', 
        ref:'centre_examen', 
        id:56, 
        value:'123456' 
    }, { 
        type:'input',
        ref:'dateh', 
        id:71, 
        value:'2023-11-07T00:00' 
    }, { 
        type:'input', 
        ref:'testttt',
        id:72,
        value:'1' 
    }, { 
        type:'input', 
        ref:'cmulti',
        id:73,
        value:['1', '2'] 
    }, { 
        type:'input', 
        ref:'cb',
        id:74,
        value:null 
    }, { 
        type:'input', 
        ref:'',
        id:1,
        value:'1' 
    }, { 
        type:'input', 
        ref:'user.name',
        id:2,
        value:'' 
    }, { 
        type:'input', 
        ref:'birth_name',
        id:3,
        value:'jhfgjh' 
    }, { 
        type:'input', 
        ref:'first_name',
        id:4,
        value:'jhfjhf' 
    }, { 
        type:'input', 
        ref:'first_name_bis',
        id:5,
        value:'jhfgjgfj' 
    }, { 
        type:'input', 
        ref:'date_n',
        id:15,
        value:'1923-11-07' 
    }, { 
        type:'input', 
        ref:'departement_n',
        id:16,
        value:'jhfjhf' 
    }, { 
        type:'input', 
        ref:'ville_n',
        id:17,
        value:'jhfgjhfg' 
    }, { 
        type:'input', 
        ref:'pays_n',
        id:18,
        value:'jhfjhfg' 
    }, { 
        type:'input', 
        ref:'situation_familiale',
        id:19,
        value:'jhfjhgf' 
    }, { 
        type:'input', 
        ref:'handicap', 
        id:47,
        value:'2' 
    }, { 
        type:'input', 
        ref:'amenagement',
        id:48,
        value:'2' 
    }, { 
        type:'input', 
        ref:'adresse',
        id:21,
        value:'jhfgjhg' 
    }, { 
        type:'input', 
        ref:'adresse_suite',
        id:22,
        value:'jhfgjhgf' 
    }, { 
        type:'input', 
        ref:'adresse_comp',
        id:23,
        value:'jhgfjhgf' 
    }, { 
        type:'input', 
        ref:'code_postal',
        id:24,
        value:'jhfgjhg' 
    }, { 
        type:'input', 
        ref:'ville',
        id:25,
        value:'jfgjgf' 
    }, { 
        type:'input', 
        ref:'arrondissement',
        id:26,
        value:'jhfjhfg' 
    }, { 
        type:'input', 
        ref:'pays',
        id:27,
        value:'jhfjhf' 
    }, { 
        type:'input', 
        ref:'telephone',
        id:28,
        value:'06 06 06 06 06' 
    }, { 
        type:'input', 
        ref:'telephone_pro',
        id:29,
        value:'' 
    }, { 
        type:'input', 
        ref:'telephone_mobile',
        id:30,
        value:'' 
    }, { 
        type:'input', 
        ref:'email', 
        id:31,
        value:'aa@bb.fr' 
    }, { 
        type:'input', 
        ref:'nationalite_fr', 
        id:32,
        value:'1' 
    }, { 
        type:'input', 
        ref:'nationalite', 
        id:33,
        value:null 
    }, { 
        type:'input', 
        ref:'employeur',
        id:34,
        value:'kjhgkjh' 
    }, { 
        type:'input', 
        ref:'employeur_adresse',
        id:35,
        value:'kjhgk' 
    }, { 
        type:'input', 
        ref:'employeur_adresse_suite',
        id:36,
        value:'kjhgk' 
    }, { 
        type:'input', 
        ref:'employeur_adresse_comp',
        id:37,
        value:'kjhgkj' 
    }, { 
        type:'input', 
        ref:'employeur_code_postal',
        id:38,
        value:'kjhgkjhg' 
    }, { 
        type:'input', 
        ref:'employeur_ville',
        id:39,
        value:'kjhgkjhg' 
    }, { 
        type:'input', 
        ref:'employeur_grade',
        id:40,
        value:'kjhkjhg' 
    }, { 
        type:'input', 
        ref:'employeur_qualite',
        id:41,
        value:'kjhgkjh' 
    }, { 
        type:'input', 
        ref:'employeur_fonction',
        id:42,
        value:'kjhgkjhgk' 
    }, { 
        type:'input', 
        ref:'employeur_date_entre',
        id:43,
        value:null 
    }, { 
        type:'input', 
        ref:'last_diplome',
        id:44,
        value:null 
    }, { 
        type:'input', 
        ref:'preparation_concour',
        id:45,
        value:null 
    }, { 
        type:'input', 
        ref:'preparation_details',
        id:46,
        value:null 
    }, { 
        type:'input', 
        ref:'deja_presente',
        id:57,
        value:null
    }, { 
        type:'input', 
        ref:'nbre_presentation',
        id:58,
        value:null 
    }, { 
        type:'input', 
        ref:'annees_presentation',
        id:59,
        value:null 
    }, { 
        type:'input', 
        ref:'boursier',
        id:60,
        value:null 
    }, { 
        type:'input', 
        ref:'residence',
        id:66,
        value:null 
    }, { 
        type:'input', 
        ref:'prepa_talent',
        id:67,
        value:null 
    }, { 
        type:'input', 
        ref:'periode_prepa_talent',
        id:69,
        value:null 
    }, { 
        type:'input', 
        ref:'choix_admission',
        id:70,
        value:null 
    }, { 
        type:'input', 
        ref:'photo_ident',
        id:53,
        value:null 
    }, { 
        type:'input', 
        ref:'service_civils',
        id:49,
        value:null 
    }, { 
        type:'input', 
        ref:'dernier_contrat_contractuel',
        id:50,
        value:null 
    }, { 
        type:'input', 
        ref:'piece_ident',
        id:51,
        value:null 
    }, { 
        type:'input', 
        ref:'avis_handicap',
        id:52,
        value:null 
    }, { 
        type:'input', 
        ref:'copie_diplome',
        id:54,
        value:null 
    }, { 
        type:'input', 
        ref:'recap_mandats',
        id:61,
        value:null 
    }, { 
        type:'input', 
        ref:'contrats_travail',
        id:62,
        value:null 
    }, { 
        type:'input', 
        ref:'releve_carriere',
        id:63,
        value:null 
    }, { 
        type:'input', 
        ref:'copie_diplome_bis',
        id:64,
        value:null 
    }, { 
        type:'input', 
        ref:'attestation_suiviformation_externe_spe',
        id:65,
        value:null 
    }, { 
        type:'partie', 
        ref:'concours',
        id:9,
        fullValue:[
            { cle:'root-0-0-4', value:'1111' }, 
            { cle:'root-1-0-0-0', value:'1112' }, 
            { cle:'root-1-0-1-0', value:'1211' }, 
            { cle:'root-data', value:['Navale-PC', 'ENSEA-PC', 'CS-PC'], min:1, max:3 }
        ], 
        value:['1111', '1112', '1211', 'Navale-PC', 'ENSEA-PC', 'CS-PC']
    }, { 
        type:'partie', 
        ref:'pilote', 
        id:10, 
        fullValue:[
            { cle:'root-data-0-0-4', value:['1111'], min:1, max:2 }, 
            { cle:'root-data-1-0-0-0', value:['1112'], min:1, max:1 }, 
            { cle:'root-data-1-0-1-0', value:['1212', '1213', '1214', '1215'], min:2, max:4 }
        ], 
        value:['1111', '1112', '1212', '1213', '1214', '1215'] 
    }]

    demo_check_validation = false

    index_file: any = null
    index_docs: any = null
    text_validation = ''
    position_scroll = 0
    currentPartScroll= 0

    /** 
     * scrollHandler 
     * Cette fonction gère le scroll de l'élément cible et émet un événement avec la position du scroll en pourcentage. 
     *  
     * @param e: any - L'événement de scroll 
     *  
     * @returns void 
     */
    scrollHander(e: any) {
        const marge = 125
        const scrollPos = (Number(e.target.scrollTop) + Number(e.target.offsetHeight))
        this.position_scroll = Math.round((Number(e.target.scrollTop) + Number(e.target.offsetHeight)) / (Number(e.target.scrollHeight)) * 100)
        // console.log(this.position_scroll + '%')
        this.$emit('scrollHandler', this.position_scroll)
        if (e.target.scrollTop - marge < 0) {
            this.currentPartScroll = this.$store.state.exa_formulaire.parties[0].id
        } else if ((Number(e.target.scrollTop) + Number(e.target.offsetHeight) + marge) > Number(e.target.scrollHeight)) {
            this.currentPartScroll = this.$store.state.exa_formulaire.parties[this.$store.state.exa_formulaire.parties.length - 1].id
        } else {
            for (let i = 0; i < this.$store.state.exa_formulaire.parties.length; i++) {
                let refPartAfter: any = null
                if (i < this.$store.state.exa_formulaire.parties.length - 1) {
                    refPartAfter = this.$refs['partie_' + this.$store.state.exa_formulaire.parties[i + 1].id]
                }
                const refPart: any = this.$refs['partie_' + this.$store.state.exa_formulaire.parties[i].id]
                
                if (Number(e.target.scrollTop) >= (refPart[0].$el.offsetTop - marge) && 
                    (Number(e.target.scrollTop) <= Number(refPart[0].$el.offsetTop + refPart[0].$el.offsetHeight - marge)) && 
                    (refPart[0].$el.offsetTop + marge) && (refPartAfter === null || 
                        Number(e.target.scrollTop) < Number(refPartAfter[0].$el.offsetTop + refPartAfter[0].$el.offsetHeight))) {
                    this.currentPartScroll = this.$store.state.exa_formulaire.parties[i].id
                    return 
                }
            }
        }
    }

    @Watch('check_validation')
    /** 
     * check_validationChangeHandler 
     * Cette fonction gère le changement de la validation.
     */
    check_validationChangeHandler () {
        this.demo_check_validation = this.check_validation
        if (this.demo_check_validation) {
            this.buildEtatsValidation()
            setTimeout(() => {
                const zone: any = this.$refs.validation
                if (zone !== null && zone !== undefined) {
                    zone.scrollIntoView({ behavior: 'smooth' })
                }
            }, 500)
        }
    }

    /** 
     * showVisionneuseHandler 
     * Cette fonction permet de basculer l'état de l'affichage de la visionneuse. 
     * Si la visionneuse est actuellement affichée, elle sera masquée, et vice versa. 
     *  
     * @param Aucun paramètre n'est requis pour cette fonction. 
     */
    showVisionneuseHandler () {
        if (this.visionneuse_enabled) {
            this.showVisionneuse = !this.showVisionneuse
        }
    }

    /** 
     * showVisionneuseFromInput 
     * Cette fonction permet d'afficher la visionneuse à partir d'un événement spécifique. 
     * Elle met à jour les index des fichiers et des documents en fonction des paramètres de l'événement. 
     * La fonction recherche également l'index du fichier correspondant à l'input_id spécifié dans les documents disponibles.  
     *  
     * @param e: un paramètre de type any représentant l'événement contenant les informations nécessaires pour afficher la visionneuse. 
     */
    showVisionneuseFromInput (e: any) {
        if (this.visionneuse_enabled) {
            this.showVisionneuse = true
            this.index_file = e.fileKey
            this.index_docs = '' // e.docKey
            const docsTemp = this.$store.getters['exa_formulaire/documents']
            for (let i  = 0; i < docsTemp.length; i++) {
                if (docsTemp[i].input_id === e.input_id) {
                    this.index_docs = i
                    return
                }
            }
        }
    }

    /** 
     * modeValidation 
     * Cette fonction gère le changement du mode de validation de la démo. 
     * 
     */
    modeValidation () {
        this.demo_check_validation = !this.demo_check_validation
        if (this.demo_check_validation) {
            this.buildEtatsValidation()
            setTimeout(() => {
                const zone: any = this.$refs.validation
                zone.scrollIntoView({ behavior: 'smooth' })
            }, 500)
        }
    }

    /** 
     * buildEtatsValidation 
     * Cette fonction construit le texte de validation en parcourant les parties et les inputs du formulaire. 
     *  
     */
    buildEtatsValidation () {
        this.text_validation = ''
        const partiesTemp = this.$store.getters['exa_formulaire/parties']
        for (const partieTemp of partiesTemp) {
            if (Number(partieTemp.type) === TypePartie.TYPE_AUTO) {
                if (partieTemp.anomalie !== '') {
                    if (!this.text_validation.includes((partieTemp.ordre + 1) + '. ' + partieTemp.libelle)) {
                        this.text_validation += '<br><b>' + (partieTemp.ordre + 1) + '. ' + partieTemp.libelle + '</b> : <small><i>&ensp;' + partieTemp.anomalie + '.</i></small><br/>'
                    }
                    // this.text_validation += '<small><i>&ensp;' + partieTemp.anomalie + '</i></small>'
                }
            } else {
                for (const  input of partieTemp.inputs) {
                    let conditionOk = true
                    if (input.condition) {
                        conditionOk = false
                        const inputCondTemp = this.$store.getters['exa_formulaire/getInputById'](input.condition.champ_id)
                        if (input.condition.value) {
                            if (inputCondTemp.value === input.condition.value) {
                                conditionOk = true
                            }
                        } else {
                            if (input.condition.value !== null) {
                                conditionOk = true
                            }
                        }
                    }
                    if (partieTemp.condition) {
                        conditionOk = false
                        const inputCondTempb = this.$store.getters['exa_formulaire/getInputById'](partieTemp.condition.champ_id)
                        if (partieTemp.condition.value) {
                            if (inputCondTempb.value === partieTemp.condition.value) {
                                conditionOk = true
                            }
                        } else {
                            if (partieTemp.condition.value !== null) {
                                conditionOk = true
                            }
                        }
                    }
                    if (input.requis || (input.anomalie && input.anomalie !== '')) {
                        if (input.anomalie && input.anomalie !== '' && this.$store.getters['exa_formulaire/getInputById'](input.id).value !== null && this.$store.getters['exa_formulaire/getInputById'](input.id).value !== '') {
                            if (!this.text_validation.includes((partieTemp.ordre + 1) + '. ' + partieTemp.libelle)) {
                                this.text_validation += '<br/><b>' + (partieTemp.ordre + 1) + '. ' + partieTemp.libelle + '</b><br/>'
                            }
                            this.text_validation += '<small><i>&ensp;  #' + (input.ordre + 1) + '. ' + input.libelle + ' : </i></small>'
                            this.text_validation += '<small>&ensp;' + input.anomalie + '</small><br/>'
                        } else if (input.requis && conditionOk && (this.$store.getters['exa_formulaire/getInputById'](input.id).value === null || this.$store.getters['exa_formulaire/getInputById'](input.id).value === '')) {
                            if (!this.text_validation.includes((partieTemp.ordre + 1) + '. ' + partieTemp.libelle)) {
                                this.text_validation += '<br><b>' + (partieTemp.ordre + 1) + '. ' + partieTemp.libelle + '</b><br/>'
                            }
                            this.text_validation += '<small><i>&ensp;  #' + (input.ordre + 1) + '. ' + input.libelle + ' : </i></small>'
                            this.text_validation += '<small>&ensp;Ce champ doit être renseigné.</small><br/>'
                        }
                    }
                }
            }
        }  
        this.test_validation = this.text_validation === ''
        this.$emit('validationHandler', this.text_validation === '')
    }

    /**
     * beforeUnmount
     * Réinitialise les états des modules exa_formulaire, exa_partieFormulaire et exa_input avant le démontage du composant.
     */
    beforeUnmount() {  
        this.$store.commit('exa_formulaire/RESET_STATE')
        this.$store.commit('exa_partieFormulaire/RESET_STATE')
        this.$store.commit('exa_input/RESET_STATE')
    } 
    
    /**
     * beforeCreate
     * Initialise les stores exa_formulaire, exa_input et exa_partieFormulaire, puis réinitialise leurs états.
     */
    beforeCreate() {
        registerOrCreateStore(this, 'exa_formulaire', formulaire)
        registerOrCreateStore(this, 'exa_input', input)
        registerOrCreateStore(this, 'exa_partieFormulaire', partieFormulaire)
        this.$store.commit('exa_formulaire/RESET_STATE')
        this.$store.commit('exa_partieFormulaire/RESET_STATE')
        this.$store.commit('exa_input/RESET_STATE')
    }

    /**
     * emitUpdateStructureFormulaire
     * Met à jour la structure JSON du formulaire et émet un événement pour signaler la mise à jour.
     * @param Aucun paramètre requis.
     */
    emitUpdateStructureFormulaire() {
        this.$store.dispatch('exa_formulaire/updateJson')
        this.json_structure = this.$store.getters['exa_formulaire/getJson']
        this.$emit('updateFormulaire', this.json_structure)
    }

    /**
     * emitUpdateValuesFormulaire
     * Met à jour les valeurs JSON du formulaire et émet un événement pour signaler la mise à jour.
     * @param Aucun paramètre requis.
     */
    emitUpdateValuesFormulaire() {
        this.$store.dispatch('exa_formulaire/updateJsonValues')
        this.json_value = this.$store.getters['exa_formulaire/getJsonValues']
        this.$emit('updateValuesFormulaire',  this.json_value)
        this.buildEtatsValidation()
    }

    /**
     * refValidityHandler
     * Vérifie si la référence de la partie sélectionnée est unique dans le formulaire.
     * @returns Un message d'erreur si la référence n'est pas unique, sinon une chaîne vide.
     */
    refValidityHandler () {
        if (!this.$store.getters['exa_formulaire/isRefIsUnique'](this.$store.state.exa_formulaire.partieSelect.ref, this.$store.state.exa_formulaire.partieSelect.id)) {
            return 'La référence doit être unique'
        } else {
            return ''
        }
    }

    /**
     * loadForm
     * Charge un formulaire à partir d'une valeur donnée, puis déclenche l'action pour charger le formulaire dans le store.
     * @param e: L'événement contenant la valeur du formulaire.
     */
    loadForm (e: any) {
        this.formulaireDefault = e.target.value === '' ? null : JSON.parse(e.target.value)
        this.$store.dispatch('exa_formulaire/loadFormulaire', this.formulaireDefault)
    }

    /**
     * loadFormRep
     * Charge les réponses d'un formulaire à partir d'une valeur donnée, puis déclenche l'action pour définir les valeurs dans le store.
     * @param e: L'événement contenant la valeur des réponses du formulaire.
     */
    loadFormRep (e: any) {
        this.reponsesFormulaireDefaut = e.target.value === '' ? null : JSON.parse(e.target.value)
        this.$store.dispatch('exa_formulaire/setValues', this.reponsesFormulaireDefaut)
    }

    /**
     * menuPartieHanddler
     * Fait défiler en douceur la vue vers la zone de menu d'une partie spécifique.
     * @param partie_id: L'identifiant de la partie pour laquelle le menu doit être affiché.
     */  
    menuPartieHanddler(partie_id: number) {
        if (partie_id === 0) {
            const zone: any = this.$refs.validation
            zone.scrollIntoView({ behavior: 'smooth' })
        } else {
            const zone: any = this.$refs['partie_' + partie_id]
            zone[0].$el.scrollIntoView({ behavior: 'smooth' })
        }
    }

    /**
     * conditionCheck
     * Met à jour les propriétés conditionOk des composants du formulaire en fonction des conditions spécifiées.
     * @param retour: La valeur de retour utilisée pour vérifier les conditions.
     */
    conditionCheck (retour: any) {
        this.emitUpdateStructureFormulaire()
        for (let i = 0; i < this.$store.state.exa_formulaire.parties.length; i++) {
            const inputTemp = this.$store.getters['exa_formulaire/inputsOfPartieHaveConditions'](this.$store.state.exa_formulaire.parties[i].id, retour.ident)
            if (this.$store.state.exa_formulaire.parties[i].condition || (inputTemp !== null && inputTemp !== undefined)) {
                const tempPart: any = this.$refs['partie_' + this.$store.state.exa_formulaire.parties[i].id]
                if (tempPart[0] !== undefined) {
                    if (inputTemp !== null && inputTemp !== undefined) {
                        const tempInput: any = tempPart[0].$refs['input_' + inputTemp.id]
                        if (tempInput[0] !== undefined) {
                            tempInput[0].conditionOk = false
                            if (inputTemp.condition.value === retour.value) {
                                tempInput[0].conditionOk = true
                            } else {
                                inputTemp.value = null
                                this.emitUpdateValuesFormulaire()
                            }
                        }
                    }
                    if (this.$store.state.exa_formulaire.parties[i].condition && Number(this.$store.state.exa_formulaire.parties[i].condition.champ_id) === Number(retour.ident)) {
                        tempPart[0].conditionOk = false
                        if (this.$store.state.exa_formulaire.parties[i].condition.value === retour.value) {
                            tempPart[0].conditionOk = true
                        }
                        if (tempPart[0].$vnode !== undefined && tempPart[0].$vnode.key !== undefined) {
                            tempPart[0].$vnode.key = String(tempPart[0].$vnode.key).split('_')[0] + '_' + Math.random()
                        }
                    } 
                }
            }
        }
    }

    /**
     * modeLectureChangeHandler
     * Gère le changement du mode de lecture dans le formulaire.
     * @param e: L'événement contenant la valeur du mode de lecture.
     */    
    modeLectureChangeHandler (e: any) {
        this.mode_lecture_from_dev = !this.mode_lecture_from_dev
    }

    /**
     * modeEditChangeHandler
     * Gère le changement du mode d'édition dans le formulaire.
     */
    modeEditChangeHandler () {
        this.mode_edit_from_dev = !this.mode_edit_from_dev
    }

    /**
     * ajouterPartie
     * Ajoute une nouvelle partie au formulaire.
     * @param Aucun paramètre requis.
     */
    ajouterPartie () {
        this.$store.dispatch('exa_formulaire/addPartie')
        this.otherParties = this.$store.state.exa_formulaire.parties
        this.buildDataPositionPartie()
        this.select_position_placement_default_value = 'after'
        this.otherInputs = this.$store.getters['exa_formulaire/inputs']
        this.buildForConditionSelectableInputs()
        this.showModalEditionPartie = true
    }

    /**
     * buildForConditionSelectableInputs
     * Construit les options pour les champs sélectionnables dans les conditions.
     * @param Aucun paramètre requis.
     */
    buildForConditionSelectableInputs () {
        const optionsTemp: Array<any> = []
        for (let i = 0; i < this.otherInputs.length; i++) {
            optionsTemp.push({
                value: this.otherInputs[i].id,
                libelle: this.otherInputs[i].libelle,
                ordre: i + 1
            })
        }
        this.condition_champ_input_type_reponse = 1
        this.forConditionSelectableInputs = null
        this.forConditionSelectableInputs = {
            options: optionsTemp  
        }      
    }

    /**
     * changeHandler
     * Gère les différents types de changements dans la partie du formulaire sélectionnée.
     * @param retour: L'objet contenant les informations du changement.
     */
    changeHandler (retour: any) {
        switch (retour.ident) {
            case 'select_condition_champ_input_type_reponse':
                this.condition_champ_input_type_reponse = retour.value
                if (Number(retour.value) === 1) {
                    this.$store.state.exa_formulaire.partieSelect.condition.value = null
                }
                break
            case 'libelle_input': 
                this.$store.state.exa_formulaire.partieSelect.libelle = retour.value
                break   
            case 'ref_input': 
                this.$store.state.exa_formulaire.partieSelect.ref = retour.value
                break
            case 'select_position_placement':
                this.select_position_placement_default_value = retour.value
                break
            case 'select_position_partie':
                this.select_position_parties_default_value = retour.value               
                break  
            case 'condition_input':
                this.$store.state.exa_formulaire.partieSelect.condition = null
                if (retour.value) {
                    this.$store.state.exa_formulaire.partieSelect.condition = {
                        champ_id: null,
                        value: null
                    }
                    if (this.forConditionSelectableInputs.options.length === 1) {
                        this.$store.state.exa_formulaire.partieSelect.condition.champ_id = this.forConditionSelectableInputs.options[0].value
                        this.conditionInput = this.$store.getters['exa_formulaire/getInputById'](this.forConditionSelectableInputs.options[0].value)
                    } else {
                        this.$store.state.exa_formulaire.partieSelect.condition.champ_id = null
                        this.conditionInput = null
                    }
                } else {
                    this.conditionInput = null
                    this.$store.state.exa_formulaire.partieSelect.condition = null
                }
                break 
            case 'select_condition_champ_input':
                this.$store.state.exa_formulaire.partieSelect.condition.champ_id = retour.value
                this.conditionInput = this.$store.getters['exa_formulaire/getInputById'](retour.value)
                break
            case 'input_condition_value_input':
                this.$store.state.exa_formulaire.partieSelect.condition.value = retour.value
                break

            default:
                if (retour instanceof Event) {
                    const eventRetour: any = retour
                    if (eventRetour.target.id === 'ps_description') {
                        this.$store.state.exa_formulaire.partieSelect.description = eventRetour.target.value
                    }
                    if (eventRetour.target.id === 'ps_datasup') {
                        this.$store.state.exa_formulaire.partieSelect.data = JSON.parse(eventRetour.target.value)
                    }
                    if (eventRetour.target.id === 'se_datasup') {
                        this.$store.state.exa_formulaire.partieSelect.ref = eventRetour.target.value
                        this.$store.state.exa_formulaire.partieSelect.data = this.data_sup[eventRetour.target.value]
                    }
                    if (eventRetour.target.id === 'select_type_partie') {
                        this.$store.state.exa_formulaire.partieSelect.type = eventRetour.target.value
                        if (Number(this.$store.state.exa_formulaire.partieSelect.type) !== TypePartie.TYPE_AUTO) {
                            this.$store.state.exa_formulaire.partieSelect.data = null
                            this.$store.state.exa_formulaire.partieSelect.ref = null
                        }
                    }
                }
                break
        }
    // this.emitUpdateStructureFormulaire()
    }

    /**
     * conditionValueInputHandler
     * Gère le changement de la valeur de condition dans un champ d'entrée.
     * @param retour: L'objet contenant la valeur du champ d'entrée de condition.
     */
    conditionValueInputHandler(retour: any) {
        this.changeHandler({ ident: 'input_condition_value_input', value: retour.value })
    }

    /**
     * editPartie
     * Gère l'édition d'une partie du formulaire.
     * @param partie: L'objet représentant la partie à éditer.
     */
    editPartie(partie: PartieFormulaireInterface) {
        this.$store.dispatch('exa_formulaire/setPartieSelect', partie)
        this.otherParties  = this.$store.state.exa_formulaire.parties.filter((partieTemp: any) =>  Number(partieTemp.id) !== Number(partie.id))
        this.buildDataPositionPartie()
        this.select_position_placement_default_value = this.$store.state.exa_formulaire.partieSelect.ordre === 0 ? 'before' : 'after'
        this.otherInputs = this.$store.getters['exa_formulaire/inputs'](partie.id)
        this.buildForConditionSelectableInputs()
        this.condition_champ_input_type_reponse = 1
        if (this.$store.state.exa_formulaire.partieSelect.condition && !isNull(this.$store.state.exa_formulaire.partieSelect.condition.value)) {
            this.conditionInput = this.$store.getters['exa_formulaire/getInputById'](this.$store.state.exa_formulaire.partieSelect.condition.champ_id)
            this.condition_champ_input_type_reponse = 2
        }
        this.showModalEditionPartie = true
    }

    /**
     * buildDataPositionPartie
     * Construit les données de positionnement des parties pour les options de sélection.
     * @param Aucun paramètre requis.
     */
    buildDataPositionPartie () {
        const optionsTemp: Array<any> = []
        for (let i = 0; i < this.otherParties.length; i++) {
            optionsTemp.push({
                value: this.otherParties[i].id,
                libelle: this.otherParties[i].libelle,
                ordre: i + 1
            })
            if ((Number(this.$store.state.exa_formulaire.partieSelect.ordre) === 0  && 
            ((Number(this.$store.state.exa_formulaire.partieSelect.id) === 0 && Number(this.otherParties[i].ordre) === 0) || Number(this.otherParties[i].ordre) === 1)) || 
                (Number(this.$store.state.exa_formulaire.partieSelect.ordre) === (Number(this.otherParties[i].ordre)  + 1))) {
                this.select_position_parties_default_value =  this.otherParties[i].id
            }
        }
        this.data_position_parties = null
        this.data_position_parties = {
            options: optionsTemp  
        }      
    }

    /**
     * updateJsonFormulaireLibelle
     * Met à jour le libellé du formulaire dans le store et émet un événement pour signaler la mise à jour de la structure du formulaire.
     * @param e: L'événement contenant la nouvelle valeur du libellé du formulaire.
     */
    updateJsonFormulaireLibelle (e: any) {
        this.$store.dispatch('exa_formulaire/setLibelle', e.value)
        this.emitUpdateStructureFormulaire()
    }

    /**
     * updateJsonFormulaireDescription
     * Met à jour la description du formulaire dans le store et émet un événement pour signaler la mise à jour de la structure du formulaire.
     * @param e: L'événement contenant la nouvelle valeur de la description du formulaire.
     */
    updateJsonFormulaireDescription (e: any) {
        this.$store.dispatch('exa_formulaire/setDescription', e.target.value)
        this.emitUpdateStructureFormulaire()
    }
    
    /**
     * editPartieSuite
     * Sauvegarde la partie sélectionnée, met à jour l'ordre des parties, réinitialise la partie sélectionnée, masque la fenêtre modale d'édition de partie, trie les parties selon leur ordre, puis émet un événement pour signaler la mise à jour de la structure du formulaire.
     * @param Aucun paramètre requis.
     */
    editPartieSuite() {
        this.$store.dispatch('exa_formulaire/savePartieSelect')
        this.$store.dispatch('exa_formulaire/setOrderParties', { way: this.select_position_placement_default_value, markedPartieId: this.select_position_parties_default_value })
        this.$store.dispatch('exa_formulaire/setPartieSelect', null)
        this.showModalEditionPartie = false
        this.$store.state.exa_formulaire.parties.sort((a: PartieFormulaireInterface, b: PartieFormulaireInterface) => Number(a.ordre) > Number(b.ordre) ? 1 : (Number(a.ordre) < Number(b.ordre) ? -1 : 0))
        this.emitUpdateStructureFormulaire()
    }
    
    /**
     * cancelEditPartie
     * Annule l'édition de la partie en cours en masquant la fenêtre modale d'édition.
     * @param Aucun paramètre requis.
     */
    cancelEditPartie() {
        this.showModalEditionPartie = false
    }

    /**
     * deletePartie
     * Supprime une partie du formulaire en déclenchant l'action pour définir la partie sélectionnée dans le store, puis affiche la fenêtre modale de confirmation de suppression.
     * @param partie: L'objet représentant la partie à supprimer.
     */
    deletePartie(partie: PartieFormulaireInterface) {
        this.$store.dispatch('exa_formulaire/setPartieSelect', partie)
        this.showModalMessageDeletePartie = true
    }

    /**
     * deletePartieSuite
     * Effectue les actions nécessaires après la suppression d'une partie du formulaire, telles que la fermeture de la fenêtre modale de confirmation et la suppression de la partie sélectionnée dans le store.
     * @param Aucun paramètre requis.
     */
    deletePartieSuite() {
        this.showModalMessageDeletePartie = false
        this.$store.dispatch('exa_formulaire/removePartieSelect', null)
        this.emitUpdateStructureFormulaire()
    }

    /**
     * cancelDeletePartie
     * Annule la suppression d'une partie du formulaire en fermant la fenêtre modale de confirmation.
     * @param Aucun paramètre requis.
     */
    cancelDeletePartie() {
        this.showModalMessageDeletePartie = false
    }

    /**
     * beforeMount
     * Prépare le formulaire avant le montage du composant en chargeant la structure du formulaire et les réponses si disponibles.
     * @param Aucun paramètre requis.
     */
    beforeMount () {
        if (this.structureFormulaire) {
            this.$store.dispatch('exa_formulaire/loadFormulaire', JSON.parse(JSON.stringify(this.structureFormulaire)))
            if (this.reponsesFormulaire) {
                this.$store.dispatch('exa_formulaire/setValues', JSON.parse(JSON.stringify(this.reponsesFormulaire)))
                this.$store.dispatch('exa_formulaire/updateJsonValues')
            }
        }  else if (this.withDataDefault) {
            this.$store.dispatch('exa_formulaire/loadFormulaire', this.formulaireDefault)
            this.$store.dispatch('exa_formulaire/setValues', this.reponsesFormulaireDefaut)
            this.$store.dispatch('exa_formulaire/updateJsonValues')
        }
        /*        
        if (this.mode_demo) {
            this.data_sup = this.data_sup_temp
        }
        */
    }
}

